import React, { useState } from 'react';
import { FiGlobe, FiChevronDown } from 'react-icons/fi';
import { usePreferences } from '../context/ThemeContext';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ar', name: 'Arabic', flag: '🇸🇦' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
  { code: 'yo', name: 'Yoruba', flag: '🇳🇬' },
];

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language, updateLanguage } = usePreferences();
  const selectedLanguage = languages.find(l => l.code === language) || languages[0];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 transition-colors"
      >
        <FiGlobe className="text-emerald-700" />
        <span className="font-medium text-emerald-800 dark:text-gray-200">{selectedLanguage.code.toUpperCase()}</span>
        <FiChevronDown className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-emerald-100 dark:border-gray-700 z-50 animate-slide-up">
          <div className="p-2">
            <div className="px-3 py-2 border-b border-emerald-100 dark:border-gray-700">
              <p className="text-sm font-medium text-emerald-600 dark:text-gray-200">Select Language</p>
            </div>
            <div className="max-h-60 overflow-y-auto">
              {languages.map(lang => (
                <button
                  key={lang.code}
                  onClick={() => { updateLanguage(lang.code); setIsOpen(false); }}
                  className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-emerald-50 dark:hover:bg-gray-700 transition-colors ${language === lang.code ? 'bg-emerald-100 dark:bg-gray-600' : ''}`}
                >
                  <span className="text-2xl">{lang.flag}</span>
                  <span className="font-medium text-emerald-800 dark:text-gray-200">{lang.name}</span>
                  {language === lang.code && <div className="ml-auto w-2 h-2 bg-emerald-500 rounded-full" />}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;